'use strict';

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

var siteBody = document.querySelector('body');

// =================================================
// MAIN NAV TOGGLE
// =================================================

var mainNavToggle = document.querySelector('.main-nav-toggle');
var mainNavClose = document.querySelector('.main-nav-close');
var mainNav = document.querySelector('.main-nav');

mainNavToggle.addEventListener('click', function(){
	this.classList.toggle('is-active');
	mainNav.classList.toggle('is-open');
	siteBody.classList.toggle('no-scroll');
});


// // =================================================
// // VIDEO MODAL TOGGLE
// // =================================================

// var videoModalOpen = document.querySelector('.video-modal-open');
// var videoModalClose = document.querySelector('.video-modal-close');
// var videoModal = document.querySelector('.video-modal');

// if (videoModalOpen) {
//   videoModalOpen.addEventListener('click', function(){
// 		videoModal.classList.add('is-open');
// 		mainNavOpen.classList.add('is-hidden');
// 	});
// }

// if (videoModalClose) {
//   videoModalClose.addEventListener('click', function(){
// 		if(videoModal.classList.contains('is-open')) {
// 			videoModal.classList.remove('is-open');
// 			mainNavOpen.classList.remove('is-hidden');
// 		}
// 	});
// }


// =================================================
// SLIDER
// =================================================

var articleFeedSlider = document.querySelector('.article-feed--slider');

if(articleFeedSlider) {

	var slider = tns({
		container: '.article-feed--slider',
		mode: 'carousel',
		items: 1,
		slideBy: 1,
		gutter: 50,
		autoplay: false,
		autoplayButtonOutput: false,
		speed: 500,
		controls: false,
		nav: true,
		navContainer: '.slider-nav',
		responsive: {
			650: {
				items: 2
			},
			1024: {
				items: 3
			}
		}
	});

}

var caseStudiesFeedSlider = document.querySelector('.case-studies-feed--slider');

if(caseStudiesFeedSlider) {

	var slider = tns({
		container: '.case-studies-feed--slider',
		mode: 'carousel',
		items: 1,
		slideBy: 1,
		autoplay: false,
		autoplayButtonOutput: false,
		speed: 500,
		controls: false,
		nav: true,
		navContainer: '.slider-nav',
		responsive: {
			650: {
				items: 2
			},
			1024: {
				items: 3
			}
		}
	});

}

var caseStudySlider = document.querySelector('.img-gallery');

if(caseStudySlider) {

	var slider = tns({
		container: '.img-gallery',
		mode: 'carousel',
		items: 1,
		slideBy: 1,
		autoplay: false,
		autoplayButtonOutput: false,
		speed: 500,
		controls: false,
		nav: false,
		controlsContainer: '.img-gallery__controls'
	});

	document.querySelector('.img-gallery__control--next').onclick = function () { slider.goTo('next'); }; document.querySelector('.img-gallery__control--prev').onclick = function () { slider.goTo('prev'); };

}

// =================================================
// WORK PAGE FILTERS
// =================================================

var caseStudyList = document.querySelector('.case-studies-feed--filtered');
var targetSelector = '.mix';

function getSelectorFromHash() {
  var hash = window.location.hash.replace(/^#/g, "");

  var selector = hash ? "." + hash : targetSelector;

  return selector;
}

function setHash(state) {
  var selector = state.activeFilter.selector;
  var newHash = "#" + selector.replace(/^./g, "");

  if (selector === targetSelector && window.location.hash) {
    // Equivalent to filter "all", remove the hash

    history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
  } else if (
    newHash !== window.location.hash &&
    selector !== targetSelector
  ) {
    // Change the hash

    history.pushState(
      null,
      document.title,
      window.location.pathname + newHash
    ); // or history.replaceState()
  }
}

if (caseStudyList) {

  var mixer = mixitup(caseStudyList, {
    animation: {
      enable: false,
      animateResizeContainer: false,
		},
		load: {
      filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
    },
    callbacks: {
      onMixEnd: setHash // Call the setHash() method at the end of each operation
    }
  });

}

window.onhashchange = function() {
  var selector = getSelectorFromHash();

  if (selector === mixer.getState().activeFilter.selector) return; // no change

  mixer.filter(selector);
};


// =================================================
// ARTICLE PAGINATION
// =================================================

var articleFeed = document.querySelector('.article-feed');

if (articleFeed) {

  var mixer = mixitup(articleFeed, {
    animation: {
      enable: false,
      animateResizeContainer: false,
    },
    pagination: {
      limit: 9,
      hidePageListIfSinglePage: true,
      loop: true
    },
    selectors: {
      pageList: '.pagination',
      target: targetSelector
    },
    templates: {
      pager: '<button type="button" class="${classNames} btn pg-number" data-page="${pageNumber}">${pageNumber}</button>'
    }

  });

}

// =================================================
// MULTIPLE VIDEO MODALS
// =================================================

var videoToggles = document.querySelectorAll('.video-modal-open');
var modal = document.querySelector('.video-modal');
var modalVideo = document.querySelector('.video-modal-embed iframe');
var closeModal = document.querySelector('.video-modal-close');
var vimeoPlayer;

videoToggles.forEach(function (videoToggle, index) {
  videoToggle.addEventListener('click', function(e){
		//var vimeoPlayer = new Vimeo.Player(modalVideo);
    var videoID = videoToggle.dataset.videoSrc; // Grab the data
    modalVideo.src = 'https://player.vimeo.com/video/' + videoID; // Inject the src and the data into the DOM
		modal.classList.add('is-open'); // Trigger the modal
		vimeoPlayer = new Vimeo.Player(modalVideo);
		vimeoPlayer.play();
		e.preventDefault();
  });
});

if(closeModal) {
	closeModal.addEventListener('click', function(){
		modalVideo.src = ''; // Clear the src of the iframe
		modal.classList.remove('is-open');// Close the modal
	});
}